/* eslint-disable import/prefer-default-export */
export const orderStatuses = {
  transmittedToPool: 2,
};
